/*
 * @Author: your name
 * @Date: 2020-08-21 15:25:20
 * @LastEditTime: 2022-07-31 02:42:40
 * @LastEditors: Francis
 * @Description: In User Settings Edit
 * @FilePath: \ki-web-projact\src\components\lib\http.js
 */

/*
ajax请求函数模块
返回值: promise对象(返回: response.data)
 */
import axios from "axios"
import { Toast } from "vant"
import router from "../../router"
// axios.defaults.baseURL = process.env.VUE_APP_BASE_API
axios.defaults.baseURL = process.env.NODE_ENV == 'production' ? '/work':'/api'
axios.defaults.timeout = 20000
// axios.defaults.headers.post["Content-Type"] =
//   "application/x-www-form-urlencoded;charset=UTF-8;multipart/form-data"
// axios.defaults.headers.post["token"] =
//   "eyJpc3MiOiJKb2huIeyJpc3MiOiJKb2huIFd1IEp"
axios.defaults.withCredentials = true
// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    const token = localStorage.getItem('token')
    token && (config.headers.token = token)
    return config
  },
  error => {
    Toast.clear();
    return Promise.error(error)
  },
)

// 响应拦截器
axios.interceptors.response.use(
  response => {
    // return Promise.resolve(response)
    return new Promise((resolve,reject)=>{
      // console.log(response.data.code)
      let code = response.data.code 
      // console.log(code, 'code')
      if(code == 401){
        Toast.fail('token已失效');

      }else if(code !== 200){
        Toast(response.data.msg || '异常操作')
        resolve(response)
      }else{
        resolve(response)
      }
    })
  },
  // 服务器状态码不是200的情况
  error => {
    if (!error.response) {
      let res= {
          code:-1,
          msg:'网络断开了，请检查网络状况。'
      }
      return Promise.reject(res)
    }else if (error.response.status) {
      return Promise.reject(error.response)
    }
  },
)

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  compactObj(params, isEmpty)
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  compactObj(params, isEmpty)
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}

/**
 * 去除对象中所有符合条件的对象
 * @param {Object} obj 来源对象
 * @param {Function} fn 函数验证每个字段
 */
function compactObj(obj, fn) {
  for (var i in obj) {
    if (typeof obj[i] === "object") {
      compactObj(obj[i], fn)
    }
    if (fn(obj[i])) {
      delete obj[i]
    }
  }
}

// 删除空对象 删除'', null, undefined
function isEmpty(foo) {
  if (typeof foo === "object") {
    for (var i in foo) {
      return false
    }
    return true
  } else {
    return foo === "" || foo === null || foo === undefined
  }
}